var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83301 2.66663C1.55687 2.66663 1.33301 2.89048 1.33301 3.16663V4.16663C1.33301 4.44277 1.55687 4.66663 1.83301 4.66663H2.83301C3.10915 4.66663 3.33301 4.44277 3.33301 4.16663V3.16663C3.33301 2.89048 3.10915 2.66663 2.83301 2.66663H1.83301Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83301 3.66663C4.83301 3.39048 5.05687 3.16663 5.33301 3.16663H14.333C14.6091 3.16663 14.833 3.39048 14.833 3.66663C14.833 3.94277 14.6091 4.16663 14.333 4.16663H5.33301C5.05687 4.16663 4.83301 3.94277 4.83301 3.66663Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 7.16663C5.05687 7.16663 4.83301 7.39048 4.83301 7.66663C4.83301 7.94277 5.05687 8.16663 5.33301 8.16663H14.333C14.6091 8.16663 14.833 7.94277 14.833 7.66663C14.833 7.39048 14.6091 7.16663 14.333 7.16663H5.33301Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 11.1666C5.05687 11.1666 4.83301 11.3905 4.83301 11.6666C4.83301 11.9428 5.05687 12.1666 5.33301 12.1666H14.333C14.6091 12.1666 14.833 11.9428 14.833 11.6666C14.833 11.3905 14.6091 11.1666 14.333 11.1666H5.33301Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 7.16663C1.33301 6.89048 1.55687 6.66663 1.83301 6.66663H2.83301C3.10915 6.66663 3.33301 6.89048 3.33301 7.16663V8.16663C3.33301 8.44277 3.10915 8.66663 2.83301 8.66663H1.83301C1.55687 8.66663 1.33301 8.44277 1.33301 8.16663V7.16663Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83301 10.6666C1.55687 10.6666 1.33301 10.8905 1.33301 11.1666V12.1666C1.33301 12.4428 1.55687 12.6666 1.83301 12.6666H2.83301C3.10915 12.6666 3.33301 12.4428 3.33301 12.1666V11.1666C3.33301 10.8905 3.10915 10.6666 2.83301 10.6666H1.83301Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareList);
export default __webpack_public_path__ + "static/media/squareList.a38d98fa848fd4e101cca2655aaa0c8e.svg";
export { ForwardRef as ReactComponent };